import { useState } from "react";
import { faqs } from "@/mocks/site";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            常见问题
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            关于蘑菇tv成品人平台的常见疑问，这里都有答案
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden transition-all duration-200"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                aria-expanded={openIndex === index}
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <span className={`flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full transition-all duration-300 ${
                  openIndex === index
                    ? "bg-primary-500 text-background-50 rotate-45"
                    : "bg-background-200 text-foreground-500"
                }`}>
                  <i className="ri-add-line text-sm"></i>
                </span>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"
                }`}
              >
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}